import { createSvgIcon } from '@automata/mui-theme';
export const HamiltonStarletIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.0047 17.2361L20.5 29.8584V55.9849C20.5 56.7923 20.1101 57.55 19.4531 58.0192L17 59.7715V60.1368L43.4046 75.4995H48.7132C49.1818 75.4995 49.6409 75.6312 50.0382 75.8795L53.0325 77.751L75 65.1313V36.3638L42.0047 17.2361ZM40.7376 14.5012C41.5148 14.045 42.4773 14.0424 43.257 14.4944L76.7538 33.9129C77.5252 34.36 78 35.1841 78 36.0757V65.4207C78 66.3158 77.5215 67.1426 76.7453 67.5885L54.267 80.5016C53.467 80.9611 52.479 80.9428 51.6967 80.4538L48.5698 78.4995H43.2697C42.8281 78.4995 42.3943 78.3825 42.0125 78.1604L15.2428 62.5853C14.4733 62.1376 14 61.3146 14 60.4244V59.5141C14 58.7068 14.3899 57.9491 15.0469 57.4798L17.5 55.7276V29.5721C17.5 28.6853 17.9697 27.8649 18.7345 27.4161L40.7376 14.5012Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6358 28.4965C18.9136 28.0192 19.5258 27.8574 20.0031 28.1353L53.0073 47.3467L75.5079 34.629C75.9887 34.3572 76.5988 34.5267 76.8706 35.0075C77.1423 35.4883 76.9729 36.0983 76.4921 36.3701L54 49.083V78.9995C54 79.5518 53.5523 79.9995 53 79.9995C52.4477 79.9995 52 79.5518 52 78.9995V49.0745L18.9969 29.8638C18.5196 29.5859 18.3579 28.9738 18.6358 28.4965Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6358 34.4965C18.9136 34.0191 19.5258 33.8574 20.0031 34.1353L53.5031 53.6353C53.9804 53.9131 54.1421 54.5253 53.8642 55.0026C53.5864 55.4799 52.9742 55.6416 52.4969 55.3638L18.9969 35.8638C18.5196 35.5859 18.3579 34.9738 18.6358 34.4965Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77.8671 53.0014C78.1422 53.4803 77.977 54.0915 77.4981 54.3666L53.9981 67.8666C53.5192 68.1417 52.908 67.9765 52.6329 67.4977C52.3578 67.0188 52.523 66.4075 53.0019 66.1324L76.5019 52.6324C76.9808 52.3573 77.592 52.5225 77.8671 53.0014Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.914 54.0217C22.562 53.5897 23.4018 53.5731 24.0663 53.9792L51 70.4387V75.9995C51 76.5518 50.5523 76.9995 50 76.9995C49.4477 76.9995 49 76.5518 49 75.9995V72.7479L42.007 76.8615C41.531 77.1415 40.9181 76.9826 40.6381 76.5066C40.358 76.0305 40.5169 75.4176 40.993 75.1376L48.0555 70.9832L23.0234 55.6858L19.0547 58.3316C18.5952 58.6379 17.9743 58.5138 17.6679 58.0542C17.3616 57.5947 17.4858 56.9738 17.9453 56.6675L21.914 54.0217Z"
    />
  </svg>,
  'HamiltonStarletIcon'
);
